<app-banner [banner]="confirmEmailRequestPage.banner"></app-banner>
<div class="container-fluid minHeight">
  <div class="container mt-2">
    <div class="pgcontent">
      <div class="row mt-5">
        <div class="col-sm-8">
          <h4>We have sent you a eMail to confirm your account, please click the link in the message to complete your registration..</h4>
        </div>
      </div>
    </div>
  </div>
</div>
